import React from 'react';

const Privacy: React.FC = () => {
    return (
        <div className="container mx-auto px-4 py-8 max-w-4xl text-gray-300">
            <h1 className="text-3xl font-serif text-tudor-gold mb-6 tracking-widest uppercase">Privacy Policy</h1>

            <div className="space-y-6 text-sm leading-relaxed">
                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">1. Information We Collect</h2>
                    <p>When you use Tudor Chess, we may collect the following information:</p>
                    <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-400">
                        <li><strong>Account Information:</strong> When you sign up via Google or Email, we collect your email address and basic profile information (e.g., username).</li>
                        <li><strong>Game Data:</strong> We store data related to your game progress, including ELO ratings, match history, and inventory.</li>
                        <li><strong>Usage Data:</strong> We may collect anonymous data about how you interact with our application to improve user experience.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">2. How We Use Your Information</h2>
                    <p>We use the collected information to:</p>
                    <ul className="list-disc pl-5 mt-2 space-y-1 text-gray-400">
                        <li>Provide and maintain the Service.</li>
                        <li>Manage your account and game progress.</li>
                        <li>Monitor usage patterns and detect technical issues.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">3. Data Security</h2>
                    <p>We implement reasonable security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.</p>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">4. Third-Party Services</h2>
                    <p>We use Supabase for authentication and database services. Your data may be processed by these third-party providers in accordance with their privacy policies.</p>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">5. Changes to This Policy</h2>
                    <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">6. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy, please contact us at privacy@tudorchess.com.</p>
                </section>
            </div>
        </div>
    );
};

export default Privacy;
